import React from "react";
import { Check } from "lucide-react";
import { SLOT_LABEL } from "./practiceApi";

// Each session has its own colour; a day turns green with a tick once every session is done.
export const SLOT_COLOR = { morning: "#3B9AE8", midday: "#F0A23A", evening: "#8B6CF0", night: "#9FB3DA" };
export const DONE_GREEN = "#3FBF7F";

const ring = (got, of) => {
  const step = 360 / Math.max(of, got.length);
  const parts = got.map((s, i) => `${SLOT_COLOR[s]} ${i * step}deg ${(i + 1) * step}deg`);
  return `conic-gradient(${parts.join(", ")}, rgba(245,236,217,0.22) ${got.length * step}deg 360deg)`;
};

export const DayDot = ({ d, today }) => {
  const got = d.slots_done || [];
  const full = d.of && got.length >= d.of;
  const style = full ? { background: DONE_GREEN, borderColor: DONE_GREEN }
    : got.length ? { background: ring(got, d.of), borderColor: "transparent" }
      : { background: "transparent", borderColor: d.future ? "rgba(245,236,217,0.22)" : "rgba(245,236,217,0.5)" };
  return (
    <span title={`Day ${d.day}${full ? " · practice complete" : got.length ? ` · ${got.map((s) => SLOT_LABEL[s]).join(", ")}` : ""}`}
      className={`relative inline-flex h-6 w-6 items-center justify-center rounded-full border-[1.5px] transition-[background-color,transform] duration-500 ${today ? "ring-1 ring-offset-2 ring-offset-[#10213f] ring-[#d7bb7a]/60" : ""} ${full ? "scale-105" : ""}`}
      style={style} data-testid={`practice-dot-${d.day}`} data-state={full ? "complete" : got.length ? "partial" : "empty"}>
      {got.length > 0 && !full && <span className="absolute inset-[4px] rounded-full bg-[#10213f]" />}
      {full && <Check size={13} strokeWidth={3} className="text-white" />}
    </span>
  );
};

export const SlotTick = ({ s, done }) => (
  <span className="inline-flex h-5 w-5 items-center justify-center rounded-full border-[1.5px] transition-[background-color,transform] duration-500"
    style={done ? { background: SLOT_COLOR[s], borderColor: SLOT_COLOR[s], transform: "scale(1.08)" } : { borderColor: SLOT_COLOR[s] }}>
    {done && <Check size={11} strokeWidth={3} className="text-white" />}
  </span>
);

export const DotLegend = ({ slots }) => (
  <div style={{ gridTemplateColumns: `repeat(${slots.length + 2}, minmax(0, 1fr))` }} className="mt-5 grid gap-1 rounded-2xl border border-[#d7bb7a]/20 px-2 py-3 text-center text-[0.6rem] sm:text-[0.68rem] leading-tight text-[#cfc6ae]" data-testid="practice-dot-legend">
    <span className="flex flex-col items-center gap-1.5"><span className="h-5 w-5 rounded-full border-[1.5px] border-[#f5ecd9]/50" />Not started</span>
    {slots.map((s) => <span key={s} className="flex flex-col items-center gap-1.5"><SlotTick s={s} done />{SLOT_LABEL[s]}</span>)}
    <span className="flex flex-col items-center gap-1.5"><span className="inline-flex h-5 w-5 items-center justify-center rounded-full" style={{ background: DONE_GREEN }}><Check size={11} strokeWidth={3} className="text-white" /></span>Day complete</span>
  </div>
);
